import { cn } from '@/lib/utils';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

export const KpiCard = ({ label, value, delta, deltaLabel, prefix = '', suffix = '', icon: Icon, testId }) => {
  const deltaNum = parseFloat(delta) || 0;
  const isPositive = deltaNum > 0;
  const isNegative = deltaNum < 0;
  const isNeutral = deltaNum === 0;

  return (
    <div 
      className="kpi-card-hover rounded-xl border border-slate-200 bg-white shadow-[0_1px_0_rgba(15,23,42,0.04)] p-4 sm:p-5"
      data-testid={testId || `kpi-card-${label?.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs sm:text-sm font-medium text-slate-500">{label}</span>
        {delta !== undefined && delta !== null && (
          <span 
            className={cn(
              'stage-badge inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium border',
              isPositive && 'bg-emerald-50 text-emerald-700 border-emerald-100',
              isNegative && 'bg-red-50 text-red-700 border-red-100',
              isNeutral && 'bg-slate-50 text-slate-700 border-slate-200'
            )}
            data-testid={testId ? `${testId}-delta` : undefined}
          >
            {isPositive && <TrendingUp className="w-3 h-3" />}
            {isNegative && <TrendingDown className="w-3 h-3" />}
            {isNeutral && <Minus className="w-3 h-3" />}
            {isPositive ? '+' : ''}{deltaNum}%
          </span>
        )}
      </div>
      <div className="flex items-end gap-2">
        <span 
          className="font-display tabular-nums text-2xl sm:text-3xl font-bold text-slate-900"
          data-testid={testId ? `${testId}-value` : undefined}
        >
          {prefix}{typeof value === 'number' ? value.toLocaleString('de-DE') : value}{suffix}
        </span>
        {Icon && <Icon className="w-5 h-5 text-slate-400 mb-1" />}
      </div>
      {deltaLabel && (
        <p className="text-xs text-slate-500 mt-1">{deltaLabel}</p>
      )}
    </div>
  );
};

export default KpiCard;
